import actions from '../actions';
import store from '../store';

let closeModal, openModal;

// Close the modal with escape key
const onEscapeKeyDown = (e) => {
  if (e.keyCode !== 27) return;
  store.dispatch(
    actions.closeModal()
  );
};

closeModal = () => {
  if (document) {
    document.removeEventListener('keydown', onEscapeKeyDown);
    document.body.style.overflow = 'auto';
  }
};

openModal = () => {
  if (document) {
    document.addEventListener('keydown', onEscapeKeyDown);
    document.body.style.overflow = 'hidden';
  }
};

export default {
  closeModal,
  openModal
};



// WEBPACK FOOTER //
// ./src/helpers/modal.js